import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

/**
 * Analytics is async and may be unavailable (SSR, in-app browsers, blocked
 * cookies), so it resolves to null instead of throwing. There is no analytics
 * emulator, so in dev we resolve null rather than polluting production GA.
 */
export const analytics =
  process.env.NODE_ENV === 'production'
    ? isSupported().then((ok) => (ok ? getAnalytics(app) : null))
    : Promise.resolve(null);

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  // Check if already connected to avoid double initialization
  if (!auth.emulatorConfig) {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  }

  // Firestore emulator
  try {
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
  } catch (error) {
    // Already connected
  }

  // Storage emulator
  try {
    connectStorageEmulator(storage, '127.0.0.1', 9199);
  } catch (error) {
    // Already connected
  }

  // Functions emulator
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);

  console.log('🔥 Connected to Firebase Emulators');
}

export default app;